import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Body1 } from '@fluentui/react-components';
import { TableDataBody1Text, TableDataInnerList } from '../styling';

export default function TableRendererValue({
  isArray,
  isDataI18n,
  titleId,
  value,
}) {

  if (isArray) {
    return (<TableDataInnerList>
      {
        value.map((item) => (
          <li key={`table-row-${titleId}-inner-${item}`}>
            <Body1>
              {item}
            </Body1>
          </li>
        ))
      }
    </TableDataInnerList>);
  }

  if (isDataI18n) {
    return <TableDataBody1Text>
      <FormattedMessage
        id={value.id}
        defaultMessage={value.defaultMessage}
        description={value.description}
      />
    </TableDataBody1Text>;
  }

  return (
    <TableDataBody1Text>
      {value}
    </TableDataBody1Text>
  );
}
